import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/scan';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/debounceTime';
import each from 'lodash/each';
import merge from 'lodash/merge';

import { getClientLocale, I18NProvider } from '@utils/i18n';
import { actionIs } from '../../utils';
import { ProductFavorites } from './ProductFavorites';
import { ToggleFavouriteButtonAppState } from './models';
import {
  toggleFavouriteButton,
} from './actions';
import ToastContainer from "@components/ToastContainer";
import apolloWrapper from '@hoc/apolloWrapper';
import { ProductDetailsStickyBarContainer } from '@containers/ProductDetailsStickyBar';

const ProductFavoritesToggle = apolloWrapper(ProductFavorites);
const ProductDetailsStickyBar = apolloWrapper(ProductDetailsStickyBarContainer);

(function(window, document) {
    const mountToList = document.querySelectorAll('.js-toggle-favourite-buttonv2');

    if (mountToList.length) {
        each(mountToList, (mountTo) => {
            let eventStream = new Subject();
            let initialState = new ToggleFavouriteButtonAppState(window, document).getState();
            if (mountTo.dataset) {
                merge(initialState, mountTo.dataset);
            }

            let fs = [
              eventStream
                .filter(actionIs('toggleFavouriteButton'))
                .debounceTime(200)
                .map(toggleFavouriteButton),
            ];

            const root = createRoot(mountTo);

            Observable
                .merge(...fs)
                .scan((state, action) => action(state), initialState)
                .startWith(initialState)
                .subscribe(
                    function (state) {
                        const { lang, routerBasename } = getClientLocale();

                        root.render(
                          <BrowserRouter basename={routerBasename}>
                            <I18NProvider lang={lang}>
                              {
                                () =>(
                                  <>
                                    <ProductFavoritesToggle
                                      product={{
                                        id: Number(state.product.id),
                                        name: state.product.name,
                                        price: state.product.price,
                                        breadcrumbs: state.product.breadcrumbs,
                                        likes: state.starred_times,
                                        isLiked: state.isActive,
                                        catalog: state.product.catalog_slug
                                          ? { slug: state.product.catalog_slug }
                                          : undefined,
                                        brand: state.product.brand_name
                                          ? { name: state.product.brand_name }
                                          : undefined
                                      }}
                                      onChange={() => {
                                        eventStream.next({
                                          action: 'toggleFavouriteButton',
                                        })
                                      }}
                                    />
                                  </>
                                )
                              }
                            </I18NProvider>
                          </BrowserRouter>)
                    }
                );
        });
    }
}(window, document));


(function (window, document) {
  const mountTo = document.querySelector('.js-fixed-conversions');

  if (mountTo) {
    const { lang, routerBasename } = getClientLocale();
    const getAttr = (name) => mountTo.getAttribute(name);
    const root = createRoot(mountTo);

    root.render(
      <BrowserRouter basename={routerBasename}>
        <I18NProvider lang={lang}>
          {
            () => (
              <ProductDetailsStickyBar threadUrl={getAttr('data-msg-url')} />
            )
          }
        </I18NProvider>
      </BrowserRouter>,
    );
  }
}(window, document));
